const icons = {
  addon: 'fas fa-receipt',
  maintenance: 'fas fa-wrench',
  address: 'fas fa-map-marker-alt',
  company: 'fas fa-briefcase',
  job: 'fas fa-cogs',
  entity: 'fas fa-layer-group',
  tenant: 'fas fa-address-card',
  loading: 'fas fa-circle-notch fa-spin',
  hgp: 'fas fa-id-badge',
  file: 'fas fa-server',
  download: 'fas fa-download',
  remove: 'fas fa-trash-alt',
  send: 'fas fa-paper-plane',
  email: 'fas fa-envelope',
  edit: 'fas fa-edit',
  percent: 'fas fa-percent',
  lease: 'fas fa-key',
  phone: 'fas fa-phone',
  play: 'fas fa-play',
  link: 'fas fa-link',
  money: 'fa-money-check-alt',
  ticket: 'fas fa-envelope-open-text',
  create: 'fas fa-plus-square',
  cancel: 'fas fa-times',
  error: 'fas fa-times',
  calendar: 'fas fa-calendar',
  info: 'fas fa-info-circle',
  inbox: 'fas fa-inbox',
  vacancies: 'fas fa-door-open',
  tree: 'far fa-tree',
  tasks: 'fas fa-tasks',
  clock: 'fas fa-clock',
  check: 'fas fa-check',
  ban: 'fas fa-ban',
  warning: 'fas fa-exclamation-triangle',
  invoice: 'fas fa-file-invoice',
  restore: 'fas fa-sync',
  toggle: value => (value ? 'fas fa-check' : 'fas fa-times'),
  chart: 'fas fa-chart-bar',
  report: 'fas fa-chart-line',
  database: 'fas fa-database',
  columns: 'fas fa-columns',
  filter: 'fas fa-filter',
  eye: 'fas fa-eye',
  pdf: 'fas fa-file-pdf',
  csv: 'fas fa-file-csv',
  search: 'fas fa-search',
  plus: 'fas fa-plus',
  trash: 'fas fa-trash',
  spinner: 'fas fa-spinner fa-spin',
  star: 'fas fa-star',
  folder: 'fas fa-folder',
  fileInvoice: 'fas fa-file-invoice',
  coins: 'fas fa-coins',
  log: 'fas fa-clipboard-list',
  success: 'fas fa-check',
  handshake: 'fas fa-handshake',
  home: 'fas fa-home',
  tools: 'fas fa-tools',
  cog: 'fas fa-cog'
}

export { icons }
